// import React from "react";


// const WorkOrder = () => {


//     return (

//         <div>
//             home
//         </div>
//     )
// };
// export default WorkOrder;

import React, { useEffect, useState } from 'react'
import { FaCheck, FaPlus, FaSave } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select';

const WorkOrder = () => {


    const navigate = useNavigate();
    const handleBack = () => { navigate(-1); };
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userName = user ? user.Emp_Name : 'Guest';
    const userId = user ? user.Emp_id : 'Guest ID ';

    const [currentDate, setCurrentDate] = useState('');

    useEffect(() => {
        // Get the current system date in YYYY-MM-DD format
        const date = new Date().toISOString().split('T')[0];
        setCurrentDate(date); // Set the system date to state
    }, []);


    const [formData, setFormData] = useState({
        partNumber: '',
        title: '',
        workOrderDate: '',
        requiredDate: '',
        createdDate: '',
        approvedDate: '',
        createdBy: '',
        approvedBy: '',
    });

    const [formMode, setFormMode] = useState('');

    const userPermissions = user && user.permissions && user.permissions[2000]
        ? {
            add: user.permissions[2000].sub_ids[2007]?.permissions.add_permission || 0,
            edit: user.permissions[2000].sub_ids[2007]?.permissions.edit_permission || 0,
            view: user.permissions[2000].sub_ids[2007]?.permissions.view_permission || 0,
            save: user.permissions[2000].sub_ids[2007]?.permissions.save_permission || 0,
            approve: user.permissions[2000].sub_ids[2007]?.permissions.approve_permission || 0,
            print: user.permissions[2000].sub_ids[2007]?.permissions.print_permission || 0,
            close: user.permissions[2000].sub_ids[2007]?.permissions.exit_permission || 0,
            clear: user.permissions[2000].sub_ids[2007]?.permissions.refresh_permission || 0
        }
        : {};

    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'save' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };

    const [rows, setRows] = useState(Array.from({ length: 10 }, () => ({
        id: null, itemCode: '', itemDesc: '', uom: '', prodNumber: '', mainGroupCd: '', mainGroupDesc: '', subGroupCd: '', subGroupDesc: '', stk_qty: '', requiredQty: '', remarks: ''
    })));

    const handleAddRow = () => {
        setRows((prevRows) => [
            ...prevRows,
            { id: null, itemCode: '', itemDesc: '', uom: '', prodNumber: '', mainGroupCd: '', mainGroupDesc: '', subGroupCd: '', subGroupDesc: '', stk_qty: '', requiredQty: '', remarks: '' }
        ]);
    };
    const [showForm, setShowForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showApproveForm, setShowApproveForm] = useState(false);

    const handlePrint = () => {

    };

    const handleRefresh = () => {

    };

    // const handleSave = () => {

    // };





    const [items, setItems] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {


        axios.get('https://erpapi.emedha.in/pages/api/api/suppliers')
            .then((response) => {
                setSuppliers(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/itemsmasterform')
            .then((response) => {
                setItems(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });


    }, []);
    const [stockData, setStockData] = useState([]);
    const fetchStq = () => {
        fetch('https://erpapi.emedha.in/pages/api/get-stock-quantity')  // API endpoint
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();  // Parse the JSON from the response
            })
            .then((data) => {
                setStockData(data);  // Update the state with the fetched data
            })
            .catch((error) => {
                console.error('Error fetching stock data:', error);
            });
    };

    useEffect(() => {
        fetchStq();  // Call the custom fetchStq function to get the stock data
    }, []);




    const handleItemChange = (index, selectedOption) => {
        if (!selectedOption) return;

        const selectedItemCd = selectedOption.value;
        const selectedItem = items.find(item => item.itemCd === selectedItemCd);
        const stockItem = stockData.find(stock => stock.item_cd === selectedItemCd);

        if (selectedItem) {
            const newRows = [...rows];

            if (selectedItem) {
                newRows[index] = {
                    ...newRows[index],
                    itemCd: selectedItem.itemCd,
                    itemDesc: selectedItem.itemDesc,
                    itemUOM: selectedItem.itemUOM,
                    prodCode: selectedItem.prodCode,
                    Main_Grp: selectedItem.Main_Grp,
                    Sub_Grp: selectedItem.Sub_Grp,
                };
            }

            if (stockItem) {
                newRows[index] = {
                    ...newRows[index],
                    stk_qty: stockItem.stk_qty || 0,
                };
            }
            setRows(newRows);
        } else {
            console.error("Item or stock data not found for item code:", selectedItemCd);
        }
    };

    const itemOptions = items.map((item) => ({
        value: item.itemCd,
        label: `${item.itemCd}-${item.itemDesc}`,
    }));

    const [subGroups, setSubGroups] = useState([]);
    const [mainGroups, setMainGroups] = useState([]);

    useEffect(() => {
        axios.get('https://erpapi.emedha.in/pages/api/api/maingrp')
            .then((response) => {
                setMainGroups(response.data);
            })
            .catch((error) => {
                console.error('Error fetching main groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/subgrp')
            .then((response) => {
                setSubGroups(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
    }, []);

    const getMainGroupDesc = (mainGrpCode) => {
        const mainGroup = mainGroups.find(group => group.Main_Grp === mainGrpCode); // Match based on Main_Grp code
        return mainGroup ? mainGroup.Main_Grp_Desc : ''; // Return description if found, otherwise empty string
    };
    const getSubGroupDesc = (subGrpCode) => {
        const subGroup = subGroups.find(group => group.Sub_Grp === subGrpCode); // Match based on Sub_Grp code and Main_Grp code
        return subGroup ? subGroup.Sub_Grp_Desc : ''; // Return description if found, otherwise empty string Sub_Grp_Desc
    };

    // Helper function to get the description for Sub_Grp based on Main_Grp
    // const getSubGroupDesc = (subGrpCode, mainGrpCode) => {
    //     const subGroup = subGroups.find(group => group.Sub_Grp === subGrpCode || group.Main_Grp === mainGrpCode); // Match based on Sub_Grp code and Main_Grp code
    //     return subGroup ? subGroup.Sub_Grp_Desc : ''; // Return description if found, otherwise empty string Sub_Grp_Desc
    // };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({
    //       ...formData,
    //       [name]: value,
    //     });
    //   };


    // const handleSave = async (e) => {
    //     e.preventDefault();

    //     // Prepare the payload for the API
    //     const payload = {
    //       header: {
    //         partNumber: formData.partNumber,
    //         title: formData.title,
    //         workOrderDate: formData.workOrderDate,
    //         requiredDate: formData.requiredDate,
    //         createdDate: formData.createdDate,
    //         approvedDate: formData.approvedDate,
    //         createdBy: formData.createdBy,
    //         approvedBy: formData.approvedBy,
    //       },
    //       details: rows,
    //     };

    //     try {
    //       const response = await axios.post('http://localhost:5000/api/createWorkOrder', payload);
    //       if (response.status === 200) {
    //         alert('Data successfully submitted!');
    //         // Handle success (e.g., clear form, show success message, etc.)
    //       }
    //     } catch (error) {
    //       console.error('Error submitting data', error);
    //       alert('Failed to submit data');
    //     }
    //   };

    // const handleSave = () => {


    //     const partNumberInput = document.querySelector('input[name="partNumber"]');
    //     const titleInput = document.querySelector('input[name="title"]');
    //     const workOrderDateInput = document.querySelector('input[name="workOrderDate"]');
    //     const requiredDateInput = document.querySelector('input[name="requiredDate"]');
    //     const createdDateInput = document.querySelector('input[name="createdDate"]');
    //     const approvedDateInput = document.querySelector('input[name="approvedDate"]');
    //     const createdByInput = document.querySelector('input[name="Indent_Req_by"]');
    //     const approvedByInput = document.querySelector('input[name="approvedBy"]');

    //     // Check if the elements exist
    //     if (!partNumberInput || !titleInput || !workOrderDateInput || !requiredDateInput || !createdDateInput || !approvedDateInput || !createdByInput || !approvedByInput) {
    //         console.error('One or more form fields are missing');
    //         return;
    //     }

    //     // Constructing the header object for the request
    //     const header = {
    //         partNumber: partNumberInput.value,
    //         title: titleInput.value,
    //         workOrderDate: workOrderDateInput.value,
    //         requiredDate: requiredDateInput.value,
    //         createdDate: createdDateInput.value,
    //         approvedDate: approvedDateInput.value,
    //         createdBy: createdByInput.value,
    //         approvedBy: approvedByInput.value,
    //     };

    //     // Constructing the details array (assuming rows is already defined in your code)
    //     const details = rows.map(row => ({
    //         itemCode: row.itemCd,
    //         itemDesc: row.itemDesc,
    //         uom: row.itemUOM,
    //         prodNumber: row.prodCode,
    //         mainGroupCd: row.Main_Grp,
    //         subGroupCd: row.Sub_Grp,
    //         availableStock: row.stk_qty,
    //         requiredQty: row.requiredQty,
    //         remarks: row.remarks,
    //     }));

    //     const formData = {
    //         header: header,
    //         details: details,
    //     };

    //     // Make the POST request with the correct structure
    //     axios.post('https://erpapi.emedha.in/pages/api/api/createWorkOrder', formData)
    //         .then(response => {
    //             alert('Data saved successfully:', response.data);
    //         })
    //         .catch(error => {
    //             console.error('Error saving data:', error);
    //         });
    // };

    const handleSave = () => {

        if (latestWO_NO !== null) {
            alert(`WO_No Number id: ${latestWO_NO + 1}`);
        }

        // Select form input elements
        const partNumberInput = document.querySelector('input[name="partNumber"]');
        const titleInput = document.querySelector('input[name="title"]');
        const workOrderDateInput = document.querySelector('input[name="workOrderDate"]');
        const requiredDateInput = document.querySelector('input[name="requiredDate"]');
        const createdDateInput = document.querySelector('input[name="createdDate"]');
        // const approvedDateInput = document.querySelector('input[name="approvedDate"]');
        const createdByInput = document.querySelector('input[name="Indent_Req_by"]');
        // const approvedByInput = document.querySelector('input[name="approvedBy"]');

        // Check if the elements exist
        if (!partNumberInput || !titleInput || !workOrderDateInput || !requiredDateInput || !createdDateInput || !createdByInput) {
            console.error('One or more form fields are missing');
            return;
        }
        console.log(partNumberInput)
        // Construct the header object for the request
        const header = {
            partNumber: partNumberInput.value,
            title: titleInput.value,
            workOrderDate: workOrderDateInput.value,
            requiredDate: requiredDateInput.value,
            createdDate: createdDateInput.value,
            // approvedDate: approvedDateInput.value,
            createdBy: createdByInput.value,
            //  approvedBy: approvedByInput.value,
        };
        console.log(header)
        // Construct the details array (assuming 'rows' is an array of form row data)
        const details = rows.map(row => ({
            itemCode: row.itemCd,
            itemDesc: row.itemDesc,
            uom: row.itemUOM,
            prodNumber: row.prodCode,
            mainGroupCd: row.Main_Grp,
            mainGroupDesc: getMainGroupDesc(row.Main_Grp),
            subGroupCd: row.Sub_Grp,
            subGroupDesc: getSubGroupDesc(row.Sub_Grp),
            availableStock: row.stk_qty || '0',
            requiredQty: row.requiredQty,
            remarks: row.remarks,
        }));

        // Combine header and details into formData
        const formData = {
            header: header,
            details: details,
        };

        // Send the data to the backend via axios POST request
        axios.post('https://erpapi.emedha.in/pages/api/api/createWorkOrder', formData)
            .then(response => {
                // console.log(response)
                // const workOrderId = response.data.Wo_no;
                alert(`Data saved successfully `);
                console.log(response.data);
                window.location.reload();
            })
            .catch(error => {
                console.error('Error saving data:', error);
            });
    };



    const [rowsEdit, setEditRows] = useState('')
    const [woNo, setWoNo] = useState([])
    const [woNoo, setWoNoo] = useState([])
    const [selectedWoNo, setSelectedWoNo] = useState(null);

    useEffect(() => {
        axios.get('https://erpapi.emedha.in/pages/api/api/getWoNos') // API URL
            .then(response => {
                setWoNoo(response.data)
                const options = response.data.map(wo => ({
                    label: wo, // Use Wo_no as the label
                    value: wo  // Use Wo_no as the value
                }));
                setWoNo(options);
            })
            .catch(error => {
                console.error('Error fetching Wo_no data:', error);
            });
    }, []);

    console.log(woNoo)
    const latestWO_NO = woNoo.length > 0 ? Math.max(...woNoo) : null;

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedWoNo(selectedOption); // Safely update the selectedWoNo
        } else {
            setSelectedWoNo(null); // If no option is selected, set it to null
        }
    };

    console.log(woNo);
    console.log(selectedWoNo)

    function formatDateToDateInput(date) {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        if (selectedWoNo) {
            axios.get(`https://erpapi.emedha.in/pages/api/api/getWorkOrder/${selectedWoNo.value}`)
                .then(response => {
                    const { header, details } = response.data;
                    setFormData({
                        partNumber: header.Part_No,
                        title: header.Title,
                        workOrderDate: formatDateToDateInput(header.Wo_Dt),
                        requiredDate: formatDateToDateInput(header.Req_Date),
                        createdDate: formatDateToDateInput(header.Created_Dt),
                        approvedDate: formatDateToDateInput(header.Approve_Dt),
                        createdBy: header.Created_By,
                        approvedBy: header.Approved_By
                    });
                    setRows(details); // Set details data (table rows)
                })
                .catch(err => {
                    console.error("Error fetching work order", err);
                });
        }
    }, [selectedWoNo]);


    console.log('this is rows data', rows);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    // Handle row input change
    const handleRowChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        const headerData = {
            ...formData,
            details: rows  // Add details as 'rows'
        };

        // axios.put(`https://erpapi.emedha.in/pages/api/api/editWorkOrder/${selectedWoNo.value}`, { header: headerData })
        //     .then(response => {
        axios.put(`https://erpapi.emedha.in/pages/api/api/editWorkOrder/${selectedWoNo.value}`, headerData)
            .then(response => {
                alert("Work order updated successfully");
                window.location.reload();
            })
            .catch(err => {
                console.error("Error updating work order", err);
                alert("Failed to update work order");
            });
    };

    const [status, setStatus] = useState(''); // Approval status message
    const [loading, setLoading] = useState(false); // Loading state
    const [error, setError] = useState('');

    const checkApprovalStatus = async (e) => {
        e.preventDefault();  // Prevent default form submission

        if (!selectedWoNo.value) {
            alert('Please enter a valid Work Order ID');
            return;
        }

        setLoading(true);  // Start loading
        setStatus('');  // Clear previous status message

        try {
            // Prepare data to submit (Work Order number and the User ID who is approving)
            const approvalData = {
                approvedBy: userId,  // Use the input field value for "Approved.By"
                approvedDate: currentDate,
            };

            // Send PUT request to approve the Work Order
            const response = await axios.put(
                `https://erpapi.emedha.in/pages/api/approve-work-order/${selectedWoNo.value}`,
                approvalData,
                {
                    headers: {
                        'Content-Type': 'application/json'  // Ensure that the request is sent as JSON
                    }
                }
            );

            if (response.status === 200) {
                // If Work Order is successfully approved
                alert('Work Order has been approved successfully.');
                setStatus('Work Order approved successfully.');
                window.location.reload();
            }
        } catch (error) {
            if (error.response) {
                // If there is an error from the server (e.g., Work Order is already approved)
                alert(error.response.data);  // Handle specific error message from server
                setStatus(error.response.data);
            } else {
                // Handle other errors
                alert('Error approving the Work Order.');
                setStatus('Error approving the Work Order.');
            }
        } finally {
            setLoading(false);  // Set loading to false after the request completes
        }
    };


    const [approveemail, setApprovedEmail] = useState([]);

    const fetchSuppliers = () => {
        axios
            .get("https://erpapi.emedha.in/pages/api/user")
            .then((response) => {

                setApprovedEmail(response.data.users);
            })
            .catch((error) => {
                console.error("Error fetching suppliers:", error);
            });
    };

    useEffect(() => {
        fetchSuppliers();
    }, []);
    console.log('formData.approvedBy:', formData.approvedBy);
    console.log('approveemail:', approveemail);


    const getEmployeeName = () => {
        // Check if the approveemail array has been populated
        if (!approveemail || approveemail.length === 0) {
            return 'Not Approved'; // Return 'Not Approved' if the data is not loaded
        }

        // Convert formData.approvedBy to a number to ensure type matching with Emp_id
        const approvedById = Number(formData.approvedBy);

        // Find the employee using formData.approvedBy
        const employee = approveemail.find(user => user.Emp_id === approvedById);

        return employee ? employee.Emp_Name : 'Not Approved'; // If no employee is found, return 'Not Approved'
    };

    //icons csss 

    // ✅ SAME COMMON STYLES
    const iconBox = (enabled) => ({
        width: "48px",
        height: "48px",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: enabled ? "linear-gradient(135deg, #ffffff, #f1f5ff)" : "#f0f0f0",
        boxShadow: enabled ? "0 4px 10px rgba(0,0,0,0.08)" : "none",
        cursor: enabled ? "pointer" : "not-allowed",
        opacity: enabled ? 1 : 0.5,
        transition: "all 0.3s ease",
    });

    const headerStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        borderRadius: "14px",
        background: "linear-gradient(135deg, #e0e7ff, #f8fafc)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    };

    const titleStyle = {
        color: "#1e3a8a",
        fontSize: "2rem",
        fontWeight: "700",
        letterSpacing: "1px",
    };

    const iconContainer = {
        display: "flex",
        gap: "14px",
        alignItems: "center",
    };


    return (
        <>
            <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <img src={A1} alt="item" style={{ width: "20%" }} />
                    <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>
                        WORK ORDER
                    </h1>
                    <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.add && userPermissions.add !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.add && userPermissions.add !== 0 && getButtonState('create') ? 1 : 0.5
                        }}>
                            <FaPlus size={30} onClick={() => {
                                if (userPermissions.add && userPermissions.add !== 0) {
                                    setShowForm(true);
                                    setShowEditForm(false);
                                    setFormMode('create');

                                } else {
                                    alert("You do not have permission to Add.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.edit && userPermissions.edit !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit') ? 1 : 0.5
                        }}>
                            <MdEdit size={30} onClick={() => {
                                if (userPermissions.edit && userPermissions.edit !== 0) {
                                    setShowForm(false);
                                    setShowEditForm(true);
                                    setFormMode('edit');
                                } else {
                                    alert("You do not have permission to edit.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.view && userPermissions.view !== 0 ? "pointer" : "not-allowed",
                            opacity: userPermissions.view && userPermissions.view !== 0 && getButtonState('view') ? 1 : 0.5
                        }}>
                            <LuView size={30} onClick={() => {
                                if (userPermissions.view && userPermissions.view !== 0) {
                                    setShowForm(false);
                                    setShowEditForm(true)
                                    setFormMode('view');
                                } else {
                                    alert("You do not have permission to view.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? "pointer" : "not-allowed",
                            opacity: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? 1 : 0.5
                        }}>
                            <HiOutlineRefresh size={30} onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? "pointer" : "not-allowed",
                            opacity: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? 1 : 0.5
                        }}>
                            <FaSave size={30}

                                // onClick={userPermissions.save && userPermissions.save !== 0 ? handleSave : null}
                                onClick={(e) => {
                                    if (userPermissions.save && userPermissions.save !== 0) {
                                        if (formMode === "create") {
                                            handleSave(); // If formMode is approve, use handleApprove
                                        } else if (formMode === "edit") {

                                            handleSubmit(e); // If formMode is create or edit, use handleSave
                                            alert('you saving the edited data ')
                                        }
                                        else if (formMode === "approve") {

                                            checkApprovalStatus(e); // If formMode is create or edit, use handleSave

                                        }
                                    } else {
                                        alert("You do not have permission to save.");
                                    }
                                }}
                            />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? "pointer" : "not-allowed",
                            opacity: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? 1 : 0.5
                        }}>
                            <FaCheck size={30} onClick={() => {
                                if (userPermissions.approve && userPermissions.approve !== 0) {
                                    setShowForm(false);
                                    setShowEditForm(true);
                                    setFormMode('approve');
                                } else {
                                    alert("You do not have permission to approve.");
                                }
                            }} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? "pointer" : "not-allowed",
                            opacity: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? 1 : 0.5
                        }} title='Print'>
                            <IoPrint size={30} onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null} />
                        </div>
                        <div style={{
                            width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                            opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                        }} title='Exit'>
                            <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                        </div>
                    </div>
                </div> */}

                <div style={headerStyle}>

                    {/* Logo */}
                    <img src={A1} alt="workorder" style={{ width: "270px", borderRadius: "10px" }} />

                    {/* Title */}
                    <h1 style={titleStyle}>WORK ORDER</h1>

                    {/* Actions */}
                    <div style={iconContainer}>

                        {/* Add */}
                        <div style={iconBox(userPermissions.add && userPermissions.add !== 0 && getButtonState('create'))}>
                            <FaPlus size={20} color="#2563eb"
                                onClick={() => {
                                    if (userPermissions.add && userPermissions.add !== 0) {
                                        setShowForm(true);
                                        setShowEditForm(false);
                                        setFormMode('create');
                                    } else {
                                        alert("You do not have permission to Add.");
                                    }
                                }}
                            />
                        </div>

                        {/* Edit */}
                        <div style={iconBox(userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit'))}>
                            <MdEdit size={20} color="#f59e0b"
                                onClick={() => {
                                    if (userPermissions.edit && userPermissions.edit !== 0) {
                                        setShowForm(false);
                                        setShowEditForm(true);
                                        setFormMode('edit');
                                    } else {
                                        alert("You do not have permission to edit.");
                                    }
                                }}
                            />
                        </div>

                        {/* View */}
                        <div style={iconBox(userPermissions.view && userPermissions.view !== 0 && getButtonState('view'))}>
                            <LuView size={20} color="#10b981"
                                onClick={() => {
                                    if (userPermissions.view && userPermissions.view !== 0) {
                                        setShowForm(false);
                                        setShowEditForm(true);
                                        setFormMode('view');
                                    } else {
                                        alert("You do not have permission to view.");
                                    }
                                }}
                            />
                        </div>

                        {/* Refresh */}
                        <div style={iconBox(userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear'))}>
                            <HiOutlineRefresh size={20} color="#6366f1"
                                onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null}
                            />
                        </div>

                        {/* Save (Important Logic Preserved) */}
                        <div style={iconBox(userPermissions.save && userPermissions.save !== 0 && getButtonState('save'))}>
                            <FaSave size={20} color="#22c55e"
                                onClick={(e) => {
                                    if (userPermissions.save && userPermissions.save !== 0) {

                                        if (formMode === "create") {
                                            handleSave();
                                        }
                                        else if (formMode === "edit") {
                                            handleSubmit(e);
                                            alert('you saving the edited data ');
                                        }
                                        else if (formMode === "approve") {
                                            checkApprovalStatus(e);
                                        }

                                    } else {
                                        alert("You do not have permission to save.");
                                    }
                                }}
                            />
                        </div>

                        {/* Approve */}
                        <div style={iconBox(userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve'))}>
                            <FaCheck size={20} color="#16a34a"
                                onClick={() => {
                                    if (userPermissions.approve && userPermissions.approve !== 0) {
                                        setShowForm(false);
                                        setShowEditForm(true);
                                        setFormMode('approve');
                                    } else {
                                        alert("You do not have permission to approve.");
                                    }
                                }}
                            />
                        </div>

                        {/* Print */}
                        <div style={iconBox(userPermissions.print && userPermissions.print !== 0 && getButtonState('print'))} title="Print">
                            <IoPrint size={20} color="#0ea5e9"
                                onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null}
                            />
                        </div>

                        {/* Close */}
                        <div style={iconBox(userPermissions.close && userPermissions.close !== 0 && getButtonState('close'))} title="Exit">
                            <RiCloseLargeFill size={20} color="#ef4444"
                                onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
                            />
                        </div>

                    </div>
                </div>
                <p>Welcome To Work Order: {userName}</p>
                <hr />
                {!showForm && (
                    <div
                        style={{
                            marginTop: "20px",
                            border: "2px dashed #cbd5e1",
                            borderRadius: "16px",
                            height: "320px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                            boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <div style={{ textAlign: "center", color: "#64748b" }}>

                            {/* Icon */}
                            <div
                                style={{
                                    fontSize: "48px",
                                    marginBottom: "10px",
                                    opacity: 0.6,
                                }}
                            >
                                📦
                            </div>

                            {/* Text */}
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#475569",
                                }}
                            >
                                Select an action from the header to begin
                            </h2>
                        </div>
                    </div>
                )}
                {showForm && (
                    <>

                        <div className='p-1' style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: '36px' }}>
                            <div style={{ flex: '1 1 48%', paddingRight: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '55px', color: 'darkblue' }}>WorkOrderNo:</label>
                                    <input readOnly style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', width: '40%', outline: 'none', backgroundColor: 'transparent' }} maxLength={10} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '65px', color: 'darkblue' }}>Part Number:</label>
                                    <input name="partNumber" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', width: '40%', outline: 'none', backgroundColor: 'transparent' }} maxLength={10} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '124px', color: 'darkblue' }}>Title:</label>
                                    <input name="title" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', width: '40%', outline: 'none', backgroundColor: 'transparent' }} maxLength={30} />
                                </div>
                            </div>

                            <div style={{ flex: '1 1 8%' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '40px', color: 'darkblue' }}>Work.Order.Dt:</label>
                                    <input name="workOrderDate" type="date" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '60px', color: 'darkblue' }}>Required.Dt:</label>
                                    <input name="requiredDate" type="date" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '68px', color: 'darkblue' }}>Created.Dt:</label>
                                    <input name="createdDate" value={currentDate} // Set the value from state
                                        readOnly
                                        onChange={(e) => setCurrentDate(e.target.value)} type="date" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} />
                                </div>
                                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '53px', color: 'darkblue' }}>Approved.Dt:</label>
                                    <input name="approvedDate" value={currentDate} // Set the value from state
                                        onChange={(e) => setCurrentDate(e.target.value)} type="date" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} />
                                </div> */}
                            </div>
                            <div >

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '68px', color: 'darkblue' }}>Created.By:</label>
                                    {/* <input type="text" style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} /> */}
                                    <input name="Indent_Req_by" value={user ? user.Emp_Name : ''} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                    <input name="Indent_Req_by" type="hidden" value={user ? user.User_id : ''} />
                                </div>

                                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '53px', color: 'darkblue' }}>Approved.By:</label>
                                    <input name="Indent_Req_by" value={user ? user.Emp_Name : ''} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                    <input name="Indent_Req_by" type="hidden" value={user ? user.User_id : ''} />
                                </div> */}
                            </div>

                        </div>


                        <div style={{ marginTop: '10px', overflowY: 'auto', maxHeight: '350px' }}>
                            <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Sl</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Desc</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Prod Number</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Main Group cd</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Main Group desc</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Sub Group Cd</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Sub Group desc</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Available Stock</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Required Qty</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Remarks</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>{index + 1}</td>
                                            {/* <td style={{ border: '1px solid black', textAlign: 'center' }}><input type="text" value={row.itemCode} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].itemCode = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px' }} />
                                            </td> */}
                                            <td style={{ border: '1px solid black' }}>
                                                <Select
                                                    options={itemOptions}
                                                    value={itemOptions.find(option => option.value === rows[index]?.itemCd)}
                                                    onChange={(selectedOption) => handleItemChange(index, selectedOption)}
                                                    isDisabled={formMode === 'view'}
                                                    placeholder="Select Item"
                                                    styles={{
                                                        container: (provided) => ({ ...provided, width: '150px', }),
                                                        control: (provided) => ({ ...provided, outline: 'none', backgroundColor: 'transparent', color: 'darkblue', }),
                                                        menu: (provided) => ({ ...provided, overflowY: 'auto', }),
                                                    }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}><input readOnly value={row.itemDesc} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].itemDesc = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '390px' }} /></td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}><input readOnly value={row.itemUOM} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].itemUOM = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '70px' }} /></td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}><input readOnly value={row.prodCode} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].prodCode = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '120px' }} /></td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}><input readOnly value={row.Main_Grp} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].Main_Grp = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }} /></td>

                                            {/* <td style={{ border: '1px solid black', textAlign: 'center' }}><input  value={row.mainGroupDesc} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].mainGroupDesc = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px' }} /></td>
                                           */}
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                {/* Display the description for Main_Grp */}
                                                <input readOnly
                                                    value={getMainGroupDesc(row.Main_Grp)}
                                                    onChange={(e) => {
                                                        const newRows = [...rows];
                                                        newRows[index].mainGroupDesc = e.target.value;
                                                        setRows(newRows);
                                                    }}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '150px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}><input readOnly value={row.Sub_Grp} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].Sub_Grp = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }} /></td>

                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>

                                                <input readOnly
                                                    value={getSubGroupDesc(row.Sub_Grp, row.Main_Grp)}
                                                    onChange={(e) => {
                                                        const newRows = [...rows];
                                                        newRows[index].subGroupDesc = e.target.value;
                                                        setRows(newRows);
                                                    }}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '140px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}><input readOnly value={row.stk_qty || 0} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].stk_qty = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }} /></td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input type="text" value={row.requiredQty}
                                                    maxLength={12}
                                                    onChange={(e) => {
                                                        const newRows = [...rows];
                                                        newRows[index].requiredQty = e.target.value;
                                                        setRows(newRows);
                                                    }}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }} /></td>

                                            <td style={{ border: '1px solid black', textAlign: 'center' }}><input type="text" value={row.remarks} onChange={(e) => {
                                                const newRows = [...rows];
                                                newRows[index].remarks = e.target.value;
                                                setRows(newRows);
                                            }} style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '110px' }} /></td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: 'end', border: '1px solid black' }}><button onClick={handleAddRow} style={{ padding: '5px 10px', border: '1px solid #D1D5DB', backgroundColor: 'transparent' }}><FaPlus /> Add Row</button></td>
                                    </tr>
                                </tbody>

                            </table>
                        </div>


                    </>
                )}



                {showEditForm && (

                    <>
                        <div className='p-1' style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: '36px' }}>
                            <div style={{ flex: '1 1 48%', paddingRight: '16px' }}>

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '65px', color: 'darkblue' }}>WorkOrderNo:</label>
                                    <Select
                                        value={selectedWoNo}
                                        onChange={handleChange}
                                        options={woNo}
                                        placeholder="-- Select Wo_no --"
                                    />
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '65px', color: 'darkblue' }}>Part.Number:</label>
                                    <input
                                        name="partNumber"
                                        value={formData.partNumber}
                                        onChange={handleInputChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', width: '40%', outline: 'none', backgroundColor: 'transparent' }}
                                        maxLength={10}
                                        disabled={formMode === 'view' || 'approve'}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '124px', color: 'darkblue' }}>Title:</label>
                                    <input
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '13px', width: '40%', outline: 'none', backgroundColor: 'transparent' }}
                                        maxLength={30}
                                        disabled={formMode === 'view' || 'approve'}
                                    />
                                </div>
                            </div>

                            <div style={{ flex: '1 1 8%' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '40px', color: 'darkblue' }}>Work.Order.Dt:</label>
                                    <input
                                        name="workOrderDate"
                                        type="date"
                                        value={formData.workOrderDate}
                                        onChange={handleInputChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }}
                                        disabled={formMode === 'view' || 'approve'}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '60px', color: 'darkblue' }}>Required.Dt:</label>
                                    <input
                                        name="requiredDate"
                                        type="date"
                                        value={formData.requiredDate}
                                        onChange={handleInputChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }}
                                        disabled={formMode === 'view' || 'approve'}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '68px', color: 'darkblue' }}>Created.Dt:</label>
                                    <input
                                        name="createdDate"
                                        type="date"
                                        value={formData.createdDate}
                                        onChange={handleInputChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }}
                                        disabled={formMode === 'view' || 'approve'}
                                    />
                                </div>
                                {/* {(formMode === 'view') && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: '53px', color: 'darkblue' }}>Approved.Dt view:</label>
                                        <input
                                            name="approvedDate"
                                            readOnly
                                            value={formData.approvedDate}

                                            // If approvedDate is not null or '\\N', display the date; otherwise, leave the input empty.
                                            // onChange={handleInputChange}
                                            style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }}
                                            disabled={formMode === 'view' || formMode === 'approve'} // Disable input based on form mode
                                        />
                                    </div>
                                )} */}

                                {(formMode === 'approve') && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: '53px', color: 'darkblue' }}>Approved.Dt:</label>
                                        <input
                                            name="approvedDate"
                                            readonly
                                            type="date"
                                            value={currentDate}
                                            onChange={handleInputChange}
                                            style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }}
                                            disabled={formMode === 'view' || 'approve'}
                                        />
                                    </div>
                                )}
                            </div>
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '68px', color: 'darkblue' }}>Created.By:</label>
                                    <input
                                        name="createdBy"

                                        value={formData.createdBy}
                                        onChange={handleInputChange}
                                        style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }}
                                        disabled={formMode === 'view' || 'approve'}
                                    />
                                </div>
                                {(formMode === 'view') && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: '53px', color: 'darkblue' }}>Approved.By:</label>
                                        <input
                                            name="approvedBy"
                                            // value={formData.approvedBy || 'not Approved'}
                                            value={getEmployeeName()}
                                            onChange={handleInputChange}
                                            style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }}

                                        />
                                    </div>
                                )}
                                {/* {(formMode === 'approve') && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: '53px', color: 'darkblue' }}>Approved.By:</label>
                                        <input name="Indent_Req_by" value={user ? user.Emp_Name : ''} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', outline: 'none', backgroundColor: 'transparent' }} disabled={formMode === 'view'} />
                                        <input name="Indent_Req_by" type="hidden" value={user ? user.User_id : ''} />
                                    </div>
                                )} */}
                                {(formMode === 'approve') && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: '53px', color: 'darkblue' }}>Approved.By:</label>
                                        <input
                                            name="Indent_Req_by"
                                            // value={formData.approvedBy || (user ? user.Emp_Name : '')}
                                            value={getEmployeeName() || (user ? user.Emp_Name : '')}
                                            style={{
                                                border: 'none',
                                                borderLeft: '2px solid #D1D5DB',
                                                padding: '10px',
                                                outline: 'none',
                                                backgroundColor: 'transparent',
                                            }}
                                            disabled={formMode === 'view' || 'approve'}
                                        />
                                        <input
                                            name="Indent_Req_by"
                                            type="hidden"
                                            value={user ? user.User_id : ''}
                                        />
                                    </div>
                                )}

                            </div>
                        </div>

                        <div style={{ marginTop: '10px', overflowY: 'auto', maxHeight: '350px' }}>
                            <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Sl</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Code</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Item Desc</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Prod Number</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Main Group cd</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Main Group desc</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Sub Group Cd</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Sub Group desc</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Available Stock</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Required Qty</th>
                                        <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>{index + 1}</td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    className='text-center'
                                                    type="text"
                                                    readOnly
                                                    value={row.Item_Code}
                                                    onChange={(e) => handleRowChange(index, 'itemCode', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '150px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.Item_Desc}
                                                    onChange={(e) => handleRowChange(index, 'itemDesc', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', width: '390px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.UOM}
                                                    onChange={(e) => handleRowChange(index, 'uom', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', width: '70px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.Prod_Number}
                                                    onChange={(e) => handleRowChange(index, 'prodNumber', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '120px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.Main_Group_CD}
                                                    onChange={(e) => handleRowChange(index, 'mainGroupCd', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.Main_Group_Desc}
                                                    onChange={(e) => handleRowChange(index, 'mainGroupDesc', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '150px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.Sub_Group_CD}
                                                    onChange={(e) => handleRowChange(index, 'subGroupCd', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.Sub_Group_Desc}
                                                    onChange={(e) => handleRowChange(index, 'subGroupCd', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '140px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={row.AV_Stock}
                                                    onChange={(e) => handleRowChange(index, 'availableStock', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="number"
                                                    value={row.Req_Qty}
                                                    onChange={(e) => handleRowChange(index, 'Req_Qty', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '90px' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                                <input
                                                    type="text"
                                                    value={row.Remarks}
                                                    onChange={(e) => handleRowChange(index, 'Remarks', e.target.value)}
                                                    disabled={formMode === 'view' || 'approve'}
                                                    style={{ border: 'none', backgroundColor: 'transparent', color: 'darkblue', height: '50px', width: '110px' }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>



                    </>

                )}

            </div>
        </>

    )
}

export default WorkOrder;